/* Run Culture wishlist: the hearts on cards and product pages (snippets/rc-wishlist-heart.liquid) and the
   wishlist icon in the header (snippets/rc-wishlist-header.liquid).
   Loaded once, deferred, from layout/theme.liquid. The script tag carries the settings:
     data-rc-wl-portal   customer portal origin (https://customer.runculture.net)
     data-rc-wl-klaviyo  Klaviyo public site ID
     data-rc-wl-list     Klaviyo list ID for the email sign-up
   A heart saves to the shopper's account in the portal, never only to this device:
     signed in (GET /api/wishlist answers 200): a tap fills the heart and POSTs it (DELETE to remove).
     signed out (401): a tap opens the email sheet, every time. POST /api/wishlist/claim with that one
     product signs them in and saves it; only then does the heart fill. Later taps save directly.
   The header icon opens the wishlist in the account when signed in; signed out it asks for the email
   first (a claim with no products), then opens it.
   Writes go to the portal one at a time (a queue), so two quick taps can never overwrite each other, and a
   tap before the first GET answers waits for it. Email marketing only with the sheet's opt-in box ticked;
   Klaviyo gets identify and the wishlist events either way.
   Sizes: every saved item carries a size (the one the shopper picked, else their profile size) and the sizes
   of its color with a variant id each. A heart on a product page with a size picked (data-rc-wl-size names
   the size controls; only a size the shopper tapped counts) sends that size with the save; signed out, it
   follows the claim as a PATCH.
   Drop day, one tap away: the cart drawer (snippets/rc-popup-cart.liquid, #rcWish) shows "From your wishlist"
   for a signed-in shopper, from the list already loaded here: size chips (a tap saves the size, PATCH), Add
   (window.RC_CART.add with that size's variant), In cart, Sold out or Back soon, and Add all in my sizes.
   The drawer calls RC_WL.cartSync(cart) each time it paints; nothing here ever holds the drawer up.
   Klaviyo profile properties (Wishlist Count, Wishlist Items, Wishlist Cart Link) follow the signed-in list,
   once per load and once per change, for the drop-day email link.
   window.RC_WL = { refresh(), has(id), count, signedIn, open(), items(), cartSync(cart) } and a "rc:wishlist"
   event on document after each change. */
(function () {
  'use strict';
  if (window.RC_WL) return;

  var tag = document.currentScript || document.querySelector('script[data-rc-wl-portal]');
  function conf(k, d) { var v = tag && tag.getAttribute('data-rc-wl-' + k); return v || d; }
  var PORTAL = String(conf('portal', 'https://customer.runculture.net')).replace(/\/+$/, '');
  var KSITE = conf('klaviyo', '');
  var KLIST = conf('list', '');
  var API = PORTAL + '/api/wishlist';
  var WL_PAGE = PORTAL + '/account/wishlist';
  var STORE = /(^|\.)runculture\.net$/.test(location.hostname) ? location.origin : 'https://runculture.net';
  var RM = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };

  /* the old design kept guest hearts on the device: drop that data, it is never read again */
  try { localStorage.removeItem('rc_wl_v1'); } catch (e) {}
  try { sessionStorage.removeItem('rc_wl_sheet'); } catch (e) {}

  /* ---------- state: only ever the signed-in account's list ---------- */
  var signedIn = false, known = false, email = null, items = [];
  var loadP = null;
  /* writes waiting or in flight: id -> 'add' | 'del' (the newest intent for that id wins over server lists) */
  var pend = {}, pendTok = {};
  /* size writes waiting or in flight: id -> size (wins over server lists until it settles) */
  var sizePend = {}, sizeTok = {};
  /* the portal's cart link from the latest answer that had one; stale after a write that did not */
  var link = null, linkStale = true;
  var dlink = null, dlinkStale = true;
  var queue = Promise.resolve();
  function noop() {}

  function nid(id) { return String(id == null ? '' : id).replace(/^gid:\/\/shopify\/Product\//, ''); }
  function idx(id) { id = nid(id); for (var i = 0; i < items.length; i++) if (items[i].id === id) return i; return -1; }
  function has(id) { return idx(id) > -1; }
  function abs(u) { if (!u) return ''; try { return new URL(u, STORE + '/').href; } catch (e) { return u; } }
  function handleize(s) { return String(s || '').toLowerCase().replace(/['"]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, ''); }
  function sizesOf(a) {
    return (Array.isArray(a) ? a : []).filter(function (s) { return s && s.size && s.variantId; })
      .map(function (s) { return { size: String(s.size), variantId: String(s.variantId), available: !!s.available }; });
  }
  function fromServer(it) {
    var x = { id: nid(it.productId), handle: it.handle || '', title: it.title || '', color: it.color || '', url: it.url || '', image: it.image || '', price: it.price || '',
              size: it.size || null, sizeSaved: !!it.sizeSaved, sizes: sizesOf(it.sizes), back: !!(it.restocking || it.backSoon) };
    if (x.id in sizePend) { x.size = sizePend[x.id]; x.sizeSaved = x.size != null; }
    return x;
  }
  /* the server list wins, except for a tap whose write is still queued (a removed heart does not come back) */
  function adopt(list, body) {
    var next = [], have = {};
    (list || []).forEach(function (it) {
      var x = fromServer(it);
      if (!x.id || have[x.id] || pend[x.id] === 'del') return;
      have[x.id] = 1; next.push(x);
    });
    items.forEach(function (x) { if (!have[x.id] && pend[x.id] === 'add') next.unshift(x); });
    items = next;
    if (body && 'cartLink' in body) { link = typeof body.cartLink === 'string' && body.cartLink ? body.cartLink : null; linkStale = false; }
    else linkStale = true;
    if (body && 'dropLink' in body) { dlink = typeof body.dropLink === 'string' && body.dropLink ? body.dropLink : null; dlinkStale = false; }
    else dlinkStale = true;
  }
  function inList(list, id) { return (list || []).some(function (it) { return nid(it.productId) === id; }); }
  function drop(id) { items = items.filter(function (x) { return x.id !== id; }); }
  function signOut() { signedIn = false; email = null; items = []; pend = {}; pendTok = {}; sizePend = {}; sizeTok = {}; wSel = {}; link = null; linkStale = true; dlink = null; dlinkStale = true; }
  function changed() {
    paint();
    try { document.dispatchEvent(new CustomEvent('rc:wishlist', { bubbles: true, detail: { count: items.length, ids: items.map(function (x) { return x.id; }), signedIn: signedIn } })); } catch (e) {}
    if (drawerOpen()) wishRender();
  }
  function copy(x) {
    return { id: x.id, handle: x.handle, title: x.title, color: x.color, url: x.url, image: x.image, price: x.price, size: x.size || null, sizeSaved: !!x.sizeSaved,
             sizes: (x.sizes || []).map(function (s) { return { size: s.size, variantId: s.variantId, available: s.available }; }) };
  }

  /* ---------- portal ---------- */
  function call(method, path, body) {
    var ctl = window.AbortController ? new AbortController() : null;
    var tm = setTimeout(function () { if (ctl) ctl.abort(); }, 10000);
    var opt = { method: method, credentials: 'include', headers: {}, signal: ctl ? ctl.signal : undefined };
    if (body) { opt.headers['Content-Type'] = 'application/json'; opt.body = JSON.stringify(body); }
    return fetch(API + (path || ''), opt).then(function (r) {
      clearTimeout(tm);
      return r.json().catch(function () { return {}; }).then(function (j) { return { status: r.status, ok: r.ok, body: j || {} }; });
    }, function (e) { clearTimeout(tm); throw e; });
  }

  /* resolves once the portal has said signed in or out (known), or failed to answer (known stays false) */
  var loading = false, lastTry = 0;
  function load() {
    loading = true; lastTry = Date.now();
    var p = call('GET').then(function (r) {
      if (r.status === 200) {
        known = true; signedIn = true; email = r.body.email || null;
        /* the shopper's own account email: Klaviyo can then record their wishlist events */
        if (email) kv('identify', { email: email });
        adopt(r.body.items, r.body);
        changed(); synced();
        return;
      }
      if (r.status === 401) { known = true; signOut(); changed(); }
    }).catch(noop /* offline or blocked: unknown, a tap asks again */).then(function () { loading = false; });
    loadP = p;
    /* writes queued meanwhile wait for it */
    queue = queue.then(function () { return p; });
    return p;
  }
  function whenKnown() {
    if (known) return Promise.resolve();
    if (!loadP) return load();
    return loadP.then(function () { return known ? null : load(); });
  }

  /* one write at a time from this device; the newest intent per id decides what the hearts show */
  function send(adding, id, opt, size) {
    var tok = {};
    pend[id] = adding ? 'add' : 'del'; pendTok[id] = tok;
    function settle() { if (pendTok[id] !== tok) return false; delete pend[id]; delete pendTok[id]; return true; }
    var body = { productId: id };
    if (adding && size) body.size = size;
    var run = queue.then(function () {
      if (pendTok[id] !== tok && !(id in pendTok)) return; /* dropped by a sign-out */
      return call(adding ? 'POST' : 'DELETE', '', body).then(function (r) {
        var last = settle();
        if (r.status === 200) {
          adopt(r.body.items, r.body);
          /* a 200 without the heart: the store no longer has that product */
          if (adding && last && !inList(r.body.items, id)) drop(id);
          changed(); synced(); return;
        }
        if (r.status === 401) { opt.signedOut(last); return; }
        opt.failed(last);
      }, function () { opt.failed(settle()); });
    });
    queue = run.then(noop, noop);
    return run;
  }
  /* the saved size of an item already in the list (size null clears it); queued like every write.
     quiet: no toast when it fails (the follow-up to a claim) */
  function patchSize(id, size, quiet) {
    var tok = {};
    sizePend[id] = size; sizeTok[id] = tok;
    var i = idx(id); if (i > -1) { items[i].size = size; items[i].sizeSaved = size != null; }
    function settle() { if (sizeTok[id] !== tok) return false; delete sizePend[id]; delete sizeTok[id]; return true; }
    var run = queue.then(function () {
      if (sizeTok[id] !== tok) return; /* a newer pick for this item, or a sign-out: that one is sent instead */
      return call('PATCH', '', { productId: id, size: size }).then(function (r) {
        var last = settle();
        if (r.status === 200) {
          if (last && wSel[id] === size) delete wSel[id];
          adopt(r.body.items, r.body); changed(); synced(); return;
        }
        if (r.status === 401) { known = true; signOut(); changed(); return; }
        /* 400 invalid_size or 404 not_in_wishlist: the pick still stands on this page for Add */
        if (last && !quiet) toast("Couldn't save that size. Try again.");
      }, function () { if (settle() && !quiet) toast("Couldn't save that size. Try again."); });
    });
    queue = run.then(noop, noop);
    return run;
  }

  /* ---------- hearts ---------- */
  function hearts(root) {
    root = root || document;
    var a = Array.prototype.slice.call(root.querySelectorAll ? root.querySelectorAll('[data-rc-wl]') : []);
    if (root.matches && root.matches('[data-rc-wl]')) a.unshift(root);
    return a;
  }
  function dataOf(h) {
    var g = function (k) { return h.getAttribute('data-rc-wl-' + k) || ''; };
    return { id: nid(g('id')), handle: g('handle'), title: g('title'), color: g('color'), url: abs(g('url')), image: g('img'), price: g('price') };
  }
  function nameOf(d) { return d.title + (d.color ? ' in ' + d.color : ''); }
  function markOne(h) {
    var d = dataOf(h), on = signedIn && has(d.id);
    /* one fixed label; aria-pressed says whether it is saved */
    h.setAttribute('aria-pressed', on ? 'true' : 'false');
    h.setAttribute('aria-label', 'Save ' + nameOf(d) + ' to wishlist');
    h.classList.toggle('is-on', on);
  }
  function paint() { hearts().forEach(markOne); paintHeader(); }

  /* a master page: move the heart to the color the shopper picked (the colorway product when the map has it) */
  function setColor(h, name) {
    if (!name) return;
    if (!h._rcBase) h._rcBase = dataOf(h);
    var b = h._rcBase, key = handleize(name), map = {};
    try { map = JSON.parse(h.getAttribute('data-rc-wl-map') || '{}') || {}; } catch (e) {}
    var m = map[key], u;
    if (m && m.url) u = abs(m.url);
    else {
      /* no colorway product for this color: the master with the color word (section-bundle-pdp reads it) */
      u = b.url.split('#')[0].replace(/([?&])variant=[^&]*&?/, '$1').replace(/[?&]$/, '');
      u += (u.indexOf('?') > -1 ? '&' : '?') + 'variant=' + encodeURIComponent(key);
    }
    h.setAttribute('data-rc-wl-id', m ? m.id : b.id);
    h.setAttribute('data-rc-wl-handle', m ? m.handle : b.handle);
    h.setAttribute('data-rc-wl-img', (m && m.img) || b.image);
    h.setAttribute('data-rc-wl-price', (m && m.price) || b.price);
    h.setAttribute('data-rc-wl-color', name);
    h.setAttribute('data-rc-wl-url', u);
    markOne(h);
  }
  function colorFrom(el) { return el.getAttribute('data-color') || (el.tagName === 'INPUT' ? el.value : '') || ''; }
  var ACTIVE = /--active\b|\bis-active\b|\bis-selected\b/;
  /* the size picked on this page for a heart with data-rc-wl-size (its size controls): a checked radio, a
     hidden input's value, or the button marked active. Only once the shopper tapped one of them here: the
     default template checks the first size on load, which is not their size. */
  function sizeOf(h) {
    var sel = h.getAttribute('data-rc-wl-size');
    if (!sel || !h._rcSizePicked) return null;
    var els = [];
    try { els = Array.prototype.slice.call(document.querySelectorAll(sel)); } catch (e) { return null; }
    for (var i = 0; i < els.length; i++) {
      var el = els[i], v = '';
      if (el.tagName === 'INPUT') { if (el.type === 'radio' || el.type === 'checkbox') { if (el.checked) v = el.value; } else v = el.value; }
      else if (ACTIVE.test(el.className || '') || el.getAttribute('aria-checked') === 'true' || el.getAttribute('aria-pressed') === 'true') v = el.getAttribute('data-size') || el.getAttribute('data-value') || el.value || el.textContent;
      v = String(v || '').trim();
      if (v) return v;
    }
    return null;
  }
  /* a tap (or keyboard change) on a heart's size controls marks its size as picked */
  function sizeTouch(t, e) {
    if (!e.isTrusted || !t || !t.closest) return;
    var lab = t.closest('label[for]'), tied = lab ? document.getElementById(lab.htmlFor) : null;
    hearts().forEach(function (h) {
      var sel = h.getAttribute('data-rc-wl-size'); if (!sel || h._rcSizePicked) return;
      try { if (t.closest(sel) || (tied && tied.matches(sel))) h._rcSizePicked = true; } catch (x) {}
    });
  }
  function followClick(t) {
    hearts().forEach(function (h) {
      var sel = h.getAttribute('data-rc-wl-follow'); if (!sel) return;
      var el = null;
      try { el = t.closest ? t.closest(sel) : null; } catch (e) { return; }
      if (el) setColor(h, colorFrom(el));
    });
  }
  /* on load: the control already marked active (a ?variant= link picks it before this runs) */
  function followInit(list) {
    (list || hearts()).forEach(function (h) {
      var sel = h.getAttribute('data-rc-wl-follow'), els = [];
      if (sel) { try { els = Array.prototype.slice.call(document.querySelectorAll(sel)); } catch (e) {} }
      var act = els.filter(function (e) { return /--active\b|\bis-active\b|\bis-selected\b/.test(e.className || '') || e.getAttribute('aria-checked') === 'true' || e.getAttribute('aria-pressed') === 'true' || e.checked; })[0];
      var c = act ? colorFrom(act) : h.getAttribute('data-rc-wl-color');
      if (c && (h.hasAttribute('data-rc-wl-map') || sel)) setColor(h, c);
    });
  }

  function tap(h) {
    if (h._rcWait) return;
    if (!known) {
      /* the first GET is still out (or failed): wait for the answer, then follow the rule */
      h._rcWait = true; h.setAttribute('aria-busy', 'true');
      whenKnown().then(function () {
        h._rcWait = false; h.removeAttribute('aria-busy');
        if (!known) { toast("Couldn't reach your wishlist. Try again."); return; }
        tap(h);
      });
      return;
    }
    var d = dataOf(h); if (!d.id) return;
    var size = sizeOf(h);
    if (!signedIn) { openSheet({ mode: 'save', heart: h, data: d, size: size }); return; }
    var i = idx(d.id), adding = i < 0, removed = adding ? null : items[i];
    if (adding) items.unshift({ id: d.id, handle: d.handle, title: d.title, color: d.color, url: d.url, image: d.image, price: d.price, size: size, sizeSaved: !!size, sizes: [] });
    else items.splice(i, 1);
    changed();
    pop(h);
    track(adding ? 'Added to Wishlist' : 'Removed from Wishlist', d);
    send(adding, d.id, {
      /* signed out since the page loaded: undo, then ask for the email. An add retries this product;
         a removal did not happen, so they sign in again and land on the account wishlist to remove it there */
      signedOut: function () {
        known = true; signOut(); changed();
        if (adding) openSheet({ mode: 'save', heart: h, data: d, size: size });
        else openSheet({ mode: 'view', opener: h });
      },
      failed: function (last) {
        if (!last) return;
        if (adding) drop(d.id); else if (!has(d.id)) items.unshift(removed);
        changed();
        toast("Couldn't update your wishlist. Try again.");
      }
    }, size);
  }
  function pop(h) {
    if (RM.matches || !h.animate) return;
    try { h.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.18)' }, { transform: 'scale(1)' }], { duration: 260, easing: 'ease-out' }); } catch (e) {}
  }

  /* ---------- header icon ---------- */
  function paintHeader() {
    var n = signedIn ? items.length : 0;
    Array.prototype.forEach.call(document.querySelectorAll('[data-rc-wlh]'), function (a) {
      var b = a.querySelector('[data-rc-wlh-n]');
      if (b) { b.textContent = n > 99 ? '99+' : String(n); b.hidden = n < 1; }
      a.setAttribute('aria-label', n > 0 ? 'Wishlist, ' + n + ' saved' : 'Wishlist');
    });
  }
  function headerTap(a, e) {
    if (known && signedIn) return; /* the link opens the wishlist in the account */
    if (e.button > 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    e.preventDefault();
    if (a._rcWait) return;
    if (known) { openSheet({ mode: 'view', opener: a }); return; }
    a._rcWait = true;
    whenKnown().then(function () {
      a._rcWait = false;
      if (!known || signedIn) { location.href = a.href; return; } /* unknown: the portal asks them to sign in */
      openSheet({ mode: 'view', opener: a });
    });
  }

  /* ---------- Klaviyo (public site script only) ---------- */
  function kv(method, a, b) {
    var k = window.klaviyo;
    if (!k) return;
    try {
      if (typeof k[method] === 'function') k[method](a, b);
      else if (typeof k.push === 'function') k.push(b === undefined ? [method, a] : [method, a, b]);
    } catch (e) {}
  }
  function num(p) { var n = parseFloat(String(p || '').replace(/[^0-9.]/g, '')); return isNaN(n) ? p : n; }
  function track(ev, d) {
    kv('track', ev, { ProductID: d.id, ProductName: d.title, Color: d.color || null, URL: abs(d.url), ImageURL: d.image || null, Price: num(d.price), Brand: 'Run Culture' });
  }
  function sizeIn(x, s) { for (var i = 0; i < (x.sizes || []).length; i++) if (x.sizes[i].size === s) return x.sizes[i]; return null; }
  /* the portal's link, or the same link built here when the list changed since (every saved size in stock) */
  function cartLink() {
    if (!linkStale) return link;
    var seen = {}, parts = [];
    items.forEach(function (x) {
      var s = x.size && sizeIn(x, x.size);
      if (s && s.available && !seen[s.variantId]) { seen[s.variantId] = 1; parts.push(s.variantId + ':1'); }
    });
    return parts.length ? 'https://runculture.net/cart/' + parts.join(',') + '?storefront=true' : null;
  }
  /* the drop-day link: every saved size, in stock or not (the portal's dropLink, or built here when the
     list changed since); sizes with no sellable variant have an empty variantId and are skipped */
  function dropLink() {
    if (!dlinkStale) return dlink;
    var seen = {}, parts = [];
    items.forEach(function (x) {
      var s = x.size && sizeIn(x, x.size);
      if (s && /^\d{1,20}$/.test(String(s.variantId || '')) && !seen[s.variantId]) { seen[s.variantId] = 1; parts.push(s.variantId + ':1'); }
    });
    return parts.length ? 'https://runculture.net/cart/' + parts.join(',') + '?storefront=true' : null;
  }
  /* profile properties for the drop-day email: after the list loads and after each change the portal
     confirmed, debounced, and only when something differs from what was last sent */
  var kvT = 0, kvLast = '', kvTries = 0;
  function hash(str) { var h = 2166136261; for (var i = 0; i < str.length; i++) { h ^= str.charCodeAt(i); h = Math.imul(h, 16777619); } return (h >>> 0).toString(36); }
  function synced() { clearTimeout(kvT); kvTries = 0; kvT = setTimeout(kvProfile, 700); }
  function kvProfile() {
    if (!signedIn) return;
    var k = window.klaviyo;
    if (!k) { if (kvTries++ < 5) kvT = setTimeout(kvProfile, 2000); return; } /* the onsite script can arrive later */
    var props = {
      'Wishlist Count': items.length,
      'Wishlist Items': items.map(function (x) { return [x.title, x.color, x.size].filter(function (v) { return v; }).join(', '); }),
      'Wishlist Cart Link': dropLink() || ''
    };
    var sig = (email || '') + '|' + JSON.stringify(props);
    sig = hash(sig); /* only a short fingerprint is kept, never the email or the items */
    if (!kvLast) { try { kvLast = sessionStorage.getItem('rc_wl_kv') || ''; } catch (e) {} }
    if (sig === kvLast) return;
    function go(withEmail) {
      if (sig === kvLast) return;
      kvLast = sig;
      try { sessionStorage.setItem('rc_wl_kv', sig); } catch (e) {}
      var p = {};
      if (withEmail) p.email = email;
      for (var key in props) p[key] = props[key];
      kv('identify', p);
    }
    if (email) { go(true); return; }
    /* no email from the portal: only a visitor Klaviyo already knows */
    try {
      var r = typeof k.isIdentified === 'function' ? k.isIdentified() : false;
      if (r && typeof r.then === 'function') r.then(function (y) { if (y) go(false); }, noop);
      else if (r) go(false);
    } catch (e) {}
  }
  function subscribe(addr) {
    if (!KSITE || !KLIST) return;
    try {
      fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + encodeURIComponent(KSITE), {
        method: 'POST',
        headers: { 'Content-Type': 'application/vnd.api+json', revision: '2026-07-15' },
        body: JSON.stringify({ data: { type: 'subscription', attributes: { custom_source: 'Wishlist', profile: { data: { type: 'profile', attributes: { email: addr } } } }, relationships: { list: { data: { type: 'list', id: KLIST } } } } })
      }).catch(function () {});
    } catch (e) {}
  }

  /* ---------- styles for the sheet and toast (the hearts carry their own) ---------- */
  var styled = false;
  function style() {
    if (styled) return; styled = true;
    var css = '' +
      '.rc-wls{position:fixed;inset:0;z-index:2147483000;display:flex;align-items:flex-end;justify-content:center;font-family:Montserrat,sans-serif;color:#000;-webkit-font-smoothing:antialiased}' +
      '.rc-wls[hidden]{display:none}' +
      '.rc-wls *,.rc-wls *::before,.rc-wls *::after{box-sizing:border-box}' +
      '.rc-wls__scrim{position:absolute;inset:0;background:rgba(0,0,0,.45);opacity:0;transition:opacity .2s}' +
      '.rc-wls.is-open .rc-wls__scrim{opacity:1}' +
      '.rc-wls__p{position:relative;width:100%;max-height:92vh;overflow:auto;background:#fff;border-radius:20px 20px 0 0;padding:28px 20px calc(20px + env(safe-area-inset-bottom));box-shadow:0 -8px 32px rgba(0,0,0,.12);transform:translateY(100%);transition:transform .24s cubic-bezier(.2,.8,.2,1)}' +
      '.rc-wls.is-open .rc-wls__p{transform:none}' +
      '.rc-wls__p:focus{outline:none}' +
      '.rc-wls__x{position:absolute;top:8px;right:8px;display:grid!important;place-items:center;width:44px!important;height:44px!important;min-height:0!important;padding:0!important;margin:0!important;border:0!important;background:none!important;box-shadow:none!important;color:#000;cursor:pointer}' +
      '.rc-wls__ic{display:grid;place-items:center;width:44px;height:44px;margin:0 0 14px;border-radius:50%;background:#f0f0f0}' +
      '.rc-wls__ic svg{width:22px;height:22px}' +
      '.rc-wls__h{margin:0 44px 8px 0!important;font:900 20px/1.15 Montserrat,sans-serif!important;text-transform:uppercase;letter-spacing:.02em;color:#000!important}' +
      '.rc-wls__t{margin:0 0 18px!important;font:500 14px/1.5 Montserrat,sans-serif!important;color:#444!important;max-width:34em}' +
      '.rc-wls__t a{color:#000!important;font-weight:700;text-decoration:underline!important;text-underline-offset:2px;border:0!important;box-shadow:none!important;background:none!important}' +
      '.rc-wls__f{display:grid;gap:10px;margin:0!important}' +
      '.rc-wls__in{display:block;width:100%!important;height:52px!important;min-height:0!important;margin:0!important;padding:0 18px!important;border:1px solid #cfcfcf!important;border-radius:999px!important;background:#fff!important;box-shadow:none!important;font:500 16px/1 Montserrat,sans-serif!important;color:#000!important;-webkit-appearance:none;appearance:none}' +
      '.rc-wls__in:focus{outline:2px solid #0069d9;outline-offset:1px;border-color:#000!important}' +
      '.rc-wls__in[aria-invalid="true"]{border-color:#c62828!important}' +
      '.rc-wls__err{margin:-2px 4px 0!important;font:600 13px/1.4 Montserrat,sans-serif!important;color:#c62828!important}' +
      '.rc-wls__go{display:flex!important;align-items:center;justify-content:center;gap:8px;width:100%!important;height:52px!important;min-height:0!important;margin:0!important;padding:0 20px!important;border:0!important;border-radius:999px!important;background:#000!important;color:#fff!important;font:800 13px/1 Montserrat,sans-serif!important;text-transform:uppercase;letter-spacing:.1em;cursor:pointer;box-shadow:none!important}' +
      '.rc-wls__go[aria-disabled="true"]{opacity:.6;cursor:progress}' +
      '.rc-wls__ck{display:flex!important;align-items:center;gap:12px;min-height:44px;margin:0!important;padding:0 4px!important;font:500 14px/1.4 Montserrat,sans-serif!important;color:#222!important;text-transform:none!important;letter-spacing:0!important;cursor:pointer}' +
      '.rc-wls__cb{flex:none;position:static!important;width:20px!important;height:20px!important;min-height:0!important;margin:0!important;padding:0!important;opacity:1!important;-webkit-appearance:checkbox!important;appearance:auto!important;accent-color:#000;cursor:pointer}' +
      '.rc-wls__cb:focus-visible{outline:2px solid #0069d9;outline-offset:2px}' +
      '.rc-wls__no{display:block!important;margin:10px auto 0!important;padding:0 16px!important;height:44px!important;min-height:0!important;border:0!important;background:none!important;box-shadow:none!important;font:700 13px/1 Montserrat,sans-serif!important;color:#000!important;text-decoration:underline;text-underline-offset:3px;cursor:pointer}' +
      '.rc-wl-sr{position:absolute!important;width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap;border:0}' +
      '.rc-wlt{position:fixed;left:50%;bottom:calc(16px + env(safe-area-inset-bottom));z-index:2147483001;display:flex;align-items:center;gap:12px;max-width:calc(100vw - 32px);width:max-content;padding:12px 18px;border-radius:14px;background:#000;color:#fff;font:600 14px/1.35 Montserrat,sans-serif;box-shadow:0 8px 28px rgba(0,0,0,.2);transform:translate(-50%,0);transition:opacity .2s,transform .2s}' +
      '.rc-wlt[hidden]{display:none}' +
      '.rc-wlt.is-out{opacity:0;transform:translate(-50%,8px)}' +
      '[data-rc-wl][aria-busy="true"]{cursor:progress}' +
      '@media (min-width:750px){.rc-wls{align-items:center;padding:24px}.rc-wls__p{max-width:440px;border-radius:20px;padding:36px 32px 28px;box-shadow:0 16px 48px rgba(0,0,0,.18);transform:translateY(12px);opacity:0;transition:transform .2s cubic-bezier(.2,.8,.2,1),opacity .2s}.rc-wls.is-open .rc-wls__p{transform:none;opacity:1}.rc-wls__h{font-size:22px!important}.rc-wlt{bottom:24px}}' +
      '@media (prefers-reduced-motion:reduce){.rc-wls__scrim,.rc-wls__p,.rc-wlt{transition:none!important}}';
    var s = document.createElement('style'); s.setAttribute('data-rc-wl-css', ''); s.textContent = css;
    (document.head || document.documentElement).appendChild(s);
  }

  /* ---------- toast ---------- */
  var toastEl = null, toastT = 0;
  function toast(msg) {
    style();
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'rc-wlt'; toastEl.setAttribute('role', 'status'); toastEl.setAttribute('aria-live', 'polite'); toastEl.hidden = true;
      document.body.appendChild(toastEl);
    }
    clearTimeout(toastT);
    toastEl.textContent = msg;
    toastEl.classList.remove('is-out'); toastEl.hidden = false;
    toastT = setTimeout(hideToast, 4000);
  }
  function hideToast() {
    if (!toastEl || toastEl.hidden) return;
    clearTimeout(toastT);
    if (RM.matches) { toastEl.hidden = true; return; }
    toastEl.classList.add('is-out');
    toastT = setTimeout(function () { toastEl.hidden = true; toastEl.classList.remove('is-out'); }, 220);
  }

  /* ---------- the email sheet ---------- */
  var COPY = {
    save: { h: 'Save to your wishlist', t: 'Enter your email to save it to your account. No password needed.', go: 'Save', busy: 'Saving' },
    view: { h: 'See your wishlist', t: 'Enter your email to open your wishlist in your account. No password needed.', go: 'Continue', busy: 'Opening' }
  };
  var sh = null, shP, shForm, shIn, shCk, shErr, shGo, shH, shT, shOpener = null, shPushed = false, busy = false, job = null;
  var HEART = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 20.3l-1.2-1.1C6.4 15.3 3.5 12.7 3.5 9.4 3.5 6.8 5.5 4.8 8.1 4.8c1.5 0 2.9.7 3.9 1.8 1-1.1 2.4-1.8 3.9-1.8 2.6 0 4.6 2 4.6 4.6 0 3.3-2.9 5.9-7.3 9.8L12 20.3z" fill="currentColor"/></svg>';
  var CLOSE = '<svg viewBox="0 0 20 20" width="18" height="18" aria-hidden="true" focusable="false"><path d="M5 5l10 10M15 5L5 15" stroke="currentColor" stroke-width="1.75" fill="none"/></svg>';
  function build() {
    style();
    sh = document.createElement('div');
    sh.className = 'rc-wls'; sh.hidden = true;
    sh.innerHTML =
      '<div class="rc-wls__scrim" data-rc-wls-close></div>' +
      '<div class="rc-wls__p" role="dialog" aria-modal="true" aria-labelledby="rc-wls-h" aria-describedby="rc-wls-t" tabindex="-1">' +
        '<button type="button" class="rc-wls__x" data-rc-wls-close aria-label="Close">' + CLOSE + '</button>' +
        '<div data-rc-wls-view="form">' +
          '<span class="rc-wls__ic" aria-hidden="true">' + HEART + '</span>' +
          '<h2 class="rc-wls__h" id="rc-wls-h"></h2>' +
          '<p class="rc-wls__t" id="rc-wls-t"></p>' +
          '<form class="rc-wls__f" novalidate>' +
            '<label class="rc-wl-sr" for="rc-wls-in">Email</label>' +
            '<input class="rc-wls__in" id="rc-wls-in" type="email" name="email" autocomplete="email" inputmode="email" autocapitalize="off" spellcheck="false" placeholder="Email address" required>' +
            '<p class="rc-wls__err" id="rc-wls-err" role="alert" hidden></p>' +
            '<label class="rc-wls__ck"><input class="rc-wls__cb" type="checkbox" name="consent" value="1"><span>Email me about new drops and restocks. Unsubscribe anytime.</span></label>' +
            '<button type="submit" class="rc-wls__go"></button>' +
          '</form>' +
          '<button type="button" class="rc-wls__no" data-rc-wls-close>Not now</button>' +
        '</div>' +
        '<div data-rc-wls-view="done" hidden>' +
          '<span class="rc-wls__ic" aria-hidden="true">' + HEART + '</span>' +
          '<h2 class="rc-wls__h" tabindex="-1" data-rc-wls-done-h>Saved to your wishlist</h2>' +
          '<p class="rc-wls__t" data-rc-wls-done-t></p>' +
          '<button type="button" class="rc-wls__go" data-rc-wls-close>Keep shopping</button>' +
        '</div>' +
      '</div>';
    document.body.appendChild(sh);
    shP = sh.querySelector('.rc-wls__p'); shForm = sh.querySelector('form'); shIn = sh.querySelector('.rc-wls__in');
    shErr = sh.querySelector('.rc-wls__err'); shGo = shForm.querySelector('.rc-wls__go'); shCk = sh.querySelector('.rc-wls__cb');
    shH = sh.querySelector('#rc-wls-h'); shT = sh.querySelector('#rc-wls-t');
    sh.addEventListener('click', function (e) {
      if (e.target.closest('[data-rc-wls-close]')) { e.preventDefault(); closeSheet(); return; }
      /* the account link: drop the sheet's history entry first, so Back from the account lands on this page once */
      var a = e.target.closest('a[href]');
      if (a && e.button === 0 && !(e.metaKey || e.ctrlKey || e.shiftKey || e.altKey)) { e.preventDefault(); leave(a.href); }
    });
    sh.addEventListener('keydown', onKey);
    shIn.addEventListener('input', function () { if (!shErr.hidden) { shErr.hidden = true; shIn.removeAttribute('aria-invalid'); } });
    shForm.addEventListener('submit', function (e) { e.preventDefault(); claim(); });
  }
  function view(which) {
    Array.prototype.forEach.call(sh.querySelectorAll('[data-rc-wls-view]'), function (v) { v.hidden = v.getAttribute('data-rc-wls-view') !== which; });
  }
  function focusables() {
    return Array.prototype.slice.call(shP.querySelectorAll('button, [href], input, [tabindex]:not([tabindex="-1"])')).filter(function (x) { return !x.disabled && x.getClientRects().length; });
  }
  function onKey(e) {
    if (e.key === 'Escape') { e.preventDefault(); closeSheet(); return; }
    if (e.key !== 'Tab') return;
    var f = focusables(); if (!f.length) { e.preventDefault(); return; }
    var first = f[0], last = f[f.length - 1], a = document.activeElement;
    if (e.shiftKey && (a === first || !shP.contains(a))) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && (a === last || !shP.contains(a))) { e.preventDefault(); first.focus(); }
  }
  function onPop() { if (sh && !sh.hidden && shPushed) { shPushed = false; finishClose(); } }
  function idle() { busy = false; shGo.removeAttribute('aria-disabled'); shGo.textContent = COPY[job.mode].go; }
  function openSheet(opt) {
    if (!sh) build();
    if (!sh.hidden) return;
    job = opt || { mode: 'view' };
    var c = COPY[job.mode];
    shOpener = job.heart || job.opener || document.activeElement;
    shH.textContent = c.h; shT.textContent = c.t;
    view('form'); shErr.hidden = true; shIn.removeAttribute('aria-invalid'); shCk.checked = false; idle();
    sh.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    try { history.pushState({ rcWl: 1 }, ''); shPushed = true; } catch (e) { shPushed = false; }
    window.addEventListener('popstate', onPop);
    requestAnimationFrame(function () { requestAnimationFrame(function () { sh.classList.add('is-open'); }); });
    /* phones: focus the panel, not the field, so the keyboard does not cover the sheet before it is read */
    setTimeout(function () { try { (window.matchMedia('(min-width: 750px)').matches ? shIn : shP).focus({ preventScroll: true }); } catch (e) {} }, 60);
  }
  function closeSheet() {
    if (!sh || sh.hidden) return;
    if (shPushed) { shPushed = false; try { history.back(); } catch (e) {} }
    finishClose();
  }
  function finishClose() {
    window.removeEventListener('popstate', onPop);
    sh.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    setTimeout(function () { sh.hidden = true; }, RM.matches ? 0 : 220);
    var o = shOpener; shOpener = null;
    if (o && o.focus && document.contains(o)) { try { o.focus({ preventScroll: true }); } catch (e) {} }
  }
  /* go to the account in place of the sheet's history entry, so Back from the account lands on this page once */
  function leave(url) {
    if (!shPushed) { location.href = url; return; }
    shPushed = false; window.removeEventListener('popstate', onPop);
    try { location.replace(url); } catch (x) { location.href = url; }
  }
  function showErr(msg) { shErr.textContent = msg; shErr.hidden = false; }
  function safeUrl(u) { return /^https:\/\//.test(u || '') && String(u).indexOf(PORTAL + '/') === 0 ? u : WL_PAGE; }
  function claim() {
    if (busy) return;
    var addr = String(shIn.value || '').trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(addr)) { shIn.setAttribute('aria-invalid', 'true'); showErr('Check the email address.'); shIn.focus(); return; }
    var j = job, d = j.data, consent = !!(shCk && shCk.checked);
    busy = true; shGo.setAttribute('aria-disabled', 'true'); shGo.textContent = COPY[j.mode].busy;
    call('POST', '/claim', { email: addr, productIds: d ? [d.id] : [], consent: consent }).then(function (r) {
      if (j !== job) return;
      idle();
      if (r.status === 200) {
        known = true; signedIn = true; email = r.body.email || addr;
        adopt(r.body.items, r.body);
        kv('identify', { email: email });
        var saved = !!d && has(d.id);
        if (saved) track('Added to Wishlist', d);
        changed(); synced();
        /* the size picked on the page follows the claim (the claim itself takes only products) */
        if (saved && j.size) patchSize(d.id, j.size, true);
        /* email marketing only when they ticked the box */
        if (consent) subscribe(email);
        var url = safeUrl(r.body.wishlistUrl);
        if (j.mode === 'view') { leave(url); return; }
        if (j.heart && saved) pop(j.heart);
        done(url, saved);
        return;
      }
      if (r.status === 400) { shIn.setAttribute('aria-invalid', 'true'); showErr('Check the email address.'); shIn.focus(); return; }
      showErr(j.mode === 'view' ? "Couldn't open your wishlist right now. Try again." : "Couldn't save right now. Try again.");
    }, function () {
      if (j !== job) return;
      idle();
      showErr(j.mode === 'view' ? "Couldn't open your wishlist right now. Try again." : "Couldn't save right now. Try again.");
    });
  }
  function done(url, saved) {
    var t = sh.querySelector('[data-rc-wls-done-t]');
    sh.querySelector('[data-rc-wls-done-h]').textContent = saved ? 'Saved to your wishlist' : "You're signed in";
    t.textContent = '';
    t.appendChild(document.createTextNode(saved ? 'Saved. ' : "That item couldn't be saved. "));
    var a = document.createElement('a'); a.href = url; a.textContent = 'See your wishlist';
    t.appendChild(a);
    t.appendChild(document.createTextNode(' anytime in your account.'));
    view('done');
    var h = sh.querySelector('[data-rc-wls-done-h]'); try { h.focus({ preventScroll: true }); } catch (e) {}
  }

  /* ---------- the cart drawer: "From your wishlist" ---------- */
  /* sizes picked in the drawer on this page (id -> size), until the portal has them */
  var wSel = {}, wBusy = {}, wAllBusy = false, wCart = null, wStyled = false;
  var SHOWN = 4;
  function drawerOpen() { var r = document.getElementById('rcCartDevRoot'); return !!(r && r.classList.contains('isOpen')); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (m) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m]; }); }
  var SHORT = { 'small': 'S', 'medium': 'M', 'large': 'L', 'x-large': 'XL', 'xx-large': 'XXL', '2x-large': '2XL', 'x-small': 'XS' };
  function sizeLabel(s) { return SHORT[String(s).toLowerCase()] || s; }
  function selOf(x) {
    if (x.id in wSel) return wSel[x.id];
    if (x.size && sizeIn(x, x.size)) return x.size;
    return x.sizes.length === 1 ? x.sizes[0].size : null;
  }
  function inCartMap() {
    var c = wCart || (window.RC_CART && window.RC_CART.cart ? window.RC_CART.cart() : null), m = {};
    ((c && c.items) || []).forEach(function (i) { m[String(i.variant_id)] = 1; });
    return m;
  }
  function anyIn(x, m) { return x.sizes.some(function (s) { return m[s.variantId]; }); }
  /* add | in | pick | sizeout | out | back */
  function stateOf(x, m) {
    var s = selOf(x), e = s ? sizeIn(x, s) : null;
    if (e && m[e.variantId]) return 'in';
    if (!x.sizes.some(function (z) { return z.available; })) return anyIn(x, m) ? 'in' : (x.back ? 'back' : 'out');
    if (!e) return anyIn(x, m) ? 'in' : 'pick';
    return e.available ? 'add' : 'sizeout';
  }
  /* what Add all takes: a size in stock, and nothing of that item already in the bag */
  function addable(list, m) { return list.filter(function (x) { return stateOf(x, m) === 'add' && !anyIn(x, m); }); }
  function wishList() { return signedIn ? items.filter(function (x) { return x.sizes && x.sizes.length; }) : []; }
  function nameOf2(x) { return x.title + (x.color ? ' in ' + x.color : ''); }
  var CHECK = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';
  function rowHtml(x, m) {
    var st = stateOf(x, m), sel = selOf(x), nm = esc(nameOf2(x)), url = esc(/^https?:\/\//.test(abs(x.url)) ? abs(x.url) : STORE + '/'), aid = ' id="rcWishA-' + esc(x.id) + '"';
    var img = x.image ? '<img src="' + esc(x.image + (/[?&]width=/.test(x.image) ? '' : (x.image.indexOf('?') > -1 ? '&' : '?') + 'width=160')) + '" alt="" loading="lazy">' : '';
    var act;
    if (wBusy[x.id]) act = '<button type="button"' + aid + ' class="rc-wish__add" disabled>Adding</button>';
    else if (st === 'add') act = '<button type="button"' + aid + ' class="rc-wish__add" data-rc-wish-add="' + esc(x.id) + '" aria-label="Add ' + nm + ', size ' + esc(sel) + ', to bag">Add</button>';
    else if (st === 'in') act = '<span' + aid + ' tabindex="-1" class="rc-wish__st rc-wish__st--in">' + CHECK + 'In cart</span>';
    else if (st === 'back') act = '<span' + aid + ' tabindex="-1" class="rc-wish__st rc-wish__st--back">Back soon</span>';
    else if (st === 'out') act = '<span' + aid + ' tabindex="-1" class="rc-wish__st">Sold out</span>';
    else if (st === 'sizeout') act = '<span' + aid + ' tabindex="-1" class="rc-wish__st">' + esc(sizeLabel(sel)) + ' sold out</span>';
    else act = '<span' + aid + ' tabindex="-1" class="rc-wish__st">Pick a size</span>';
    var chips = '';
    if (!(x.sizes.length === 1 && /^one size$/i.test(x.sizes[0].size))) {
      chips = '<div class="rc-wish__sizes" role="group" aria-label="Size for ' + nm + '">' + x.sizes.map(function (s, n) {
        var on = s.size === sel;
        return '<button type="button" id="rcWishS-' + esc(x.id) + '-' + n + '" class="rc-wish__chip' + (s.available ? '' : ' is-out') + '" data-rc-wish-size="' + esc(s.size) + '" data-rc-wish-id="' + esc(x.id) + '" aria-pressed="' + on + '"' +
          (s.available ? '' : ' aria-label="' + esc(s.size) + ', sold out"') + '>' + esc(sizeLabel(s.size)) + '</button>';
      }).join('') + '</div>';
    }
    return '<div class="rc-wish__row" data-rc-wish="' + esc(x.id) + '" data-state="' + st + '">' +
      '<div class="rc-wish__main">' +
        '<a class="rc-wish__img" href="' + url + '" tabindex="-1" aria-hidden="true">' + img + '</a>' +
        '<div class="rc-wish__meta"><a class="rc-wish__t" href="' + url + '">' + esc(x.title) + '</a>' +
          (x.color ? '<span class="rc-wish__c">' + esc(x.color) + '</span>' : '') +
          (x.price ? '<span class="rc-wish__p">' + esc(x.price) + '</span>' : '') + '</div>' +
        '<div class="rc-wish__act">' + act + '</div>' +
      '</div>' + chips + '</div>';
  }
  function wishRender() {
    var el = document.getElementById('rcWish'); if (!el) return;
    var list = wishList();
    if (!list.length) { if (!el.hidden || el.innerHTML) { el.hidden = true; el.innerHTML = ''; } return; }
    wishStyle();
    var m = inCartMap(), all = addable(list, m), shown = list.slice(0, SHOWN);
    /* Add all when it does more than one Add would: two or more, or one not shown here */
    var bulk = all.length > 1 || (all.length === 1 && shown.indexOf(all[0]) < 0);
    /* keep focus on the same control across a redraw */
    /* every control here has a stable id (the drawer's own redraws restore focus by id too) */
    var a = document.activeElement, fk = a && el.contains(a) && a.id ? a.id : null;
    el.innerHTML =
      '<div class="rc-wish__hd"><p class="rc-wish__h" id="rcWishH" tabindex="-1">From your wishlist</p>' +
        (list.length > SHOWN ? '<a class="rc-wish__more" href="' + esc(WL_PAGE) + '" aria-label="See all ' + list.length + ' in your wishlist">See all</a>' : '') + '</div>' +
      shown.map(function (x) { return rowHtml(x, m); }).join('') +
      (bulk ? '<button type="button" id="rcWishAll" class="rc-wish__bulk" data-rc-wish-all' + (wAllBusy ? ' disabled' : '') + '>' + (wAllBusy ? 'Adding' : 'Add all in my sizes') + '</button>' : '');
    el.setAttribute('aria-labelledby', 'rcWishH');
    el.hidden = false;
    if (fk) { var f = document.getElementById(fk); if (f) { try { f.focus({ preventScroll: true }); } catch (e) {} } }
    if (!el._rcWish) { el._rcWish = true; el.addEventListener('click', wishClick); }
  }
  function wishClick(e) {
    var t = e.target, b;
    if ((b = t.closest('[data-rc-wish-size]'))) { pickSize(b.getAttribute('data-rc-wish-id'), b.getAttribute('data-rc-wish-size')); return; }
    if ((b = t.closest('[data-rc-wish-add]'))) { var x = items[idx(b.getAttribute('data-rc-wish-add'))]; if (x) addToBag([x], false); return; }
    if (t.closest('[data-rc-wish-all]')) { addToBag(addable(wishList(), inCartMap()), true); }
  }
  function pickSize(id, size) {
    var x = items[idx(id)]; if (!x || selOf(x) === size) return;
    wSel[id] = size; wishRender();
    patchSize(id, size);
  }
  function rcEv(name, props) { try { if (window.rcEvent) window.rcEvent(name, props); } catch (e) {} }
  function addReason(err) { return (err && err.desc) ? String(err.desc) : "Couldn't add that to your bag. Try again."; }
  /* the drawer's own add (RC_CART.add: /cart/add.js, then it repaints). When several fail together
     (one sold out since), each goes on its own so the rest still land. */
  function addToBag(list, bulk) {
    var RC = window.RC_CART;
    if (!RC || typeof RC.add !== 'function' || !list.length || wAllBusy) return;
    var lines = [];
    list = list.filter(function (x) { var s = sizeIn(x, selOf(x)); if (!s || wBusy[x.id]) return false; lines.push({ id: Number(s.variantId), quantity: 1 }); return true; });
    if (!list.length) return;
    list.forEach(function (x) { wBusy[x.id] = 1; });
    if (bulk) wAllBusy = true;
    wishRender();
    /* focus stays where the tap was: the row's new state (In cart), or Add all's place */
    function finish() {
      list.forEach(function (x) { delete wBusy[x.id]; }); wAllBusy = false; wishRender();
      var el = document.getElementById('rcWish'); if (!el || el.hidden || !drawerOpen()) return;
      var f = document.getElementById(bulk ? 'rcWishAll' : 'rcWishA-' + list[0].id) || document.getElementById('rcWishH');
      if (f) { try { f.focus({ preventScroll: true }); } catch (e) {} }
    }
    rcEv('cart_wishlist_add', { n: lines.length, all: !!bulk });
    RC.add(lines).then(finish, function (err) {
      if (lines.length < 2) { finish(); toast(addReason(err)); return; }
      var bad = 0;
      lines.reduce(function (p, ln) {
        return p.then(function () {
          return fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [ln] }) })
            .then(function (r) { if (!r.ok) bad++; }, function () { bad++; });
        });
      }, Promise.resolve()).then(function () {
        return RC.refresh ? RC.refresh() : null;
      }).then(noop, noop).then(function () {
        finish();
        if (bad) toast(bad === lines.length ? "Couldn't add those to your bag. Try again." : (lines.length - bad) + ' added. ' + bad + " couldn't be added.");
      });
    });
  }
  /* the drawer painted (it opened, or the bag changed): draw from the list already here, never waiting */
  function cartSync(cart) {
    wCart = cart || null;
    setTimeout(function () {
      try { wishRender(); } catch (e) {}
      /* a list older than 5 minutes (or a portal that did not answer, after a minute) is fetched again, behind it */
      if (!loading && document.getElementById('rcWish') && Date.now() - lastTry > (known ? 300000 : 60000)) load();
    }, 0);
  }
  function wishStyle() {
    if (wStyled) return; wStyled = true;
    var R = '#rcCartDevRoot ';
    var css = '' +
      R + '.rc-wish{padding:18px 0 6px}' +
      R + '.rc-wish[hidden]{display:none}' +
      R + '.rc-wish__hd{display:flex;align-items:baseline;justify-content:space-between;gap:12px;margin:0 0 2px}' +
      R + '.rc-wish__h{margin:0;font-size:13px;font-weight:900;letter-spacing:.06em;text-transform:uppercase;text-align:left;color:var(--rc-ink,#111)}' +
      R + '.rc-wish__more{flex:none;padding:6px 0;font:800 12.5px var(--rc-font);color:var(--rc-blue,#007BFF);text-decoration:underline;text-underline-offset:3px}' +
      R + '.rc-wish__row{padding:12px 0;border-bottom:1px solid var(--rc-line,#e6e8eb);text-align:left}' +
      R + '.rc-wish__row:last-of-type{border-bottom:0}' +
      R + '.rc-wish__main{display:grid;grid-template-columns:64px minmax(0,1fr) auto;gap:12px;align-items:center}' +
      R + '.rc-wish__img{display:block;width:64px;height:64px;border-radius:10px;overflow:hidden;background:#fff;border:1px solid var(--rc-line,#e6e8eb)}' +
      R + '.rc-wish__img img{width:100%;height:100%;object-fit:contain;display:block}' +
      R + '.rc-wish__meta{min-width:0}' +
      R + '.rc-wish__t{display:block;font-size:13px;font-weight:900;letter-spacing:.04em;text-transform:uppercase;color:var(--rc-ink,#111);text-decoration:none;line-height:1.2}' +
      R + '.rc-wish__c{display:block;font-size:12.5px;color:var(--rc-muted,#5b6168);margin-top:2px}' +
      R + '.rc-wish__p{display:block;font-size:13.5px;font-weight:900;margin-top:3px;color:var(--rc-ink,#111)}' +
      R + '.rc-wish__add{height:36px;padding:0 16px;border:0;border-radius:999px;background:var(--rc-blue,#007BFF);color:#fff;font:800 12.5px var(--rc-font);cursor:pointer;white-space:nowrap}' +
      R + '.rc-wish__add:disabled{opacity:.6;cursor:default}' +
      R + '.rc-wish__st{display:inline-flex;align-items:center;gap:4px;font:800 12px var(--rc-font);color:var(--rc-muted,#5b6168);white-space:nowrap}' +
      R + '.rc-wish__st--in{color:var(--rc-blue,#007BFF)}' +
      R + '.rc-wish__st--back{color:var(--rc-blue,#007BFF)}' +
      R + '.rc-wish__st svg{width:15px;height:15px;fill:none;stroke:currentColor;stroke-width:2.4;stroke-linecap:round;stroke-linejoin:round}' +
      R + '.rc-wish__sizes{display:flex;flex-wrap:wrap;gap:6px;margin:10px 0 0 76px}' +
      R + '.rc-wish__chip{min-width:44px;height:36px;padding:0 10px;border:1.5px solid #cfd4da;border-radius:9px;background:#fff;color:var(--rc-ink,#111);font:800 12.5px var(--rc-font);cursor:pointer}' +
      R + '.rc-wish__chip.is-out{color:#8a9097;text-decoration:line-through}' +
      R + '.rc-wish__chip[aria-pressed="true"]{border-color:var(--rc-ink,#111);background:var(--rc-ink,#111);color:#fff}' +
      R + '.rc-wish__chip.is-out[aria-pressed="true"]{background:#fff;color:#8a9097}' +
      R + '.rc-wish__bulk{display:block;width:100%;height:46px;margin:10px 0 0;border:1.5px solid var(--rc-ink,#111);border-radius:12px;background:#fff;color:var(--rc-ink,#111);font:900 12.5px var(--rc-font);letter-spacing:.08em;text-transform:uppercase;cursor:pointer}' +
      R + '.rc-wish__bulk:disabled{opacity:.6;cursor:default}' +
      '@media (max-width:374px){' + R + '.rc-wish__sizes{margin-left:0}}';
    var s = document.createElement('style'); s.setAttribute('data-rc-wish-css', ''); s.textContent = css;
    (document.head || document.documentElement).appendChild(s);
  }

  /* ---------- events ---------- */
  /* a drag that ends on a heart (carousels, the poster wheel) is a swipe, not a tap */
  var down = null;
  document.addEventListener('pointerdown', function (e) { down = { x: e.clientX, y: e.clientY }; }, true);
  function dragged(e) { return !!down && e.detail > 0 && Math.abs(e.clientX - down.x) + Math.abs(e.clientY - down.y) > 12; }
  /* capture phase: a heart sits inside card links and swipeable galleries, so it must never reach them */
  document.addEventListener('click', function (e) {
    var t = e.target; if (!t || !t.closest) return;
    var h = t.closest('[data-rc-wl]');
    if (h) { e.preventDefault(); e.stopPropagation(); if (!dragged(e)) tap(h); return; }
    var a = t.closest('[data-rc-wlh]');
    if (a) { headerTap(a, e); return; }
    sizeTouch(t, e);
    followClick(t);
  }, true);
  document.addEventListener('change', function (e) { if (e.target && e.target.tagName === 'INPUT') { sizeTouch(e.target, e); followClick(e.target); } }, true);

  /* ask the portal only on pages that show a heart or the header icon */
  function ensureLoad() { if (!loadP && document.querySelector('[data-rc-wl],[data-rc-wlh]')) load(); }
  /* the default product template's desktop buy panel (.rc-overlay) takes the title out of its row:
     move the title heart next to it, so it is not left under the panel. Rows marked data-rc-wl-keep stay. */
  function place() {
    hearts().forEach(function (h) {
      if (!h.classList.contains('rc-wl--title')) return;
      var row = h._rcRow || (h._rcRow = h.closest('.rc-wl-row'));
      if (!row || row.hasAttribute('data-rc-wl-keep')) return;
      var own = row.querySelector('.product__title');
      if (own) {
        /* the row pads both sides so a centered title stays centered; a left-aligned title needs no left pad */
        var tx = own.querySelector('span') || own;
        var al = window.getComputedStyle ? getComputedStyle(tx).textAlign : 'center';
        row.classList.toggle('rc-wl-row--l', al !== 'center' && al !== '-webkit-center');
        return;
      }
      var scope = row.closest('[id^="Product--"]') || document;
      var t = scope.querySelector('.rc-overlay .product__title');
      if (t && t.nextElementSibling !== h) t.insertAdjacentElement('afterend', h);
    });
  }
  function refresh() { place(); followInit(); paint(); ensureLoad(); }

  /* hearts added after load (fetched cards, carousels, filters): marked in the next frame, added nodes only */
  var fresh = [], raf = 0;
  function flush() {
    raf = 0;
    var list = [];
    fresh.forEach(function (n) { if (n.isConnected !== false) list = list.concat(hearts(n)); });
    fresh = [];
    if (!list.length) return;
    followInit(list.filter(function (h) { return h.hasAttribute('data-rc-wl-follow') || h.hasAttribute('data-rc-wl-map'); }));
    list.forEach(markOne);
    ensureLoad();
  }
  function watch() {
    if (!window.MutationObserver || !document.body) return;
    new MutationObserver(function (recs) {
      for (var i = 0; i < recs.length; i++) {
        var add = recs[i].addedNodes;
        for (var k = 0; k < add.length; k++) if (add[k].nodeType === 1) fresh.push(add[k]);
      }
      if (fresh.length && !raf) raf = requestAnimationFrame(flush);
    }).observe(document.body, { childList: true, subtree: true });
  }

  var api = {
    refresh: refresh,
    has: function (id) { return signedIn && has(id); },
    open: function () { if (known && signedIn) location.href = WL_PAGE; else openSheet({ mode: 'view' }); },
    /* the signed-in list (copies; empty when signed out): id, title, color, url, image, price, size, sizeSaved, sizes */
    items: function () { return signedIn ? items.map(copy) : []; },
    /* snippets/rc-popup-cart.liquid calls this each time the drawer paints */
    cartSync: cartSync
  };
  Object.defineProperty(api, 'count', { enumerable: true, get: function () { return signedIn ? items.length : 0; } });
  Object.defineProperty(api, 'signedIn', { enumerable: true, get: function () { return signedIn; } });
  window.RC_WL = api;

  function start() {
    refresh();
    watch();
    /* back/forward cache: the shopper may have signed in or out, or changed the list, meanwhile */
    window.addEventListener('pageshow', function (e) { if (e.persisted && loadP) { known = false; load(); } });
    window.addEventListener('load', place);
    var rt = 0;
    window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(place, 150); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
